module.exports = __webpack_public_path__ + "static/media/rocket.555b7c6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/heading-rocket/rocket.svg
// module id = 94
// module chunks = 0